/* src/app/shredder-importer/pages/shredder-importer/shredder-importer.component.scss */
/*# sourceMappingURL=shredder-importer.component.css.map */
